import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomeComponent } from './layout/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { VendorInvoiceComponent } from './forms/vendor-invoice/vendor-invoice.component';
import { VendorRegistrationComponent } from './forms/vendor-registration/vendor-registration.component';
import { MultipleInvoicesComponent } from './forms/multiple-invoices/multiple-invoices.component';
import { ProfileComponent } from './profile/profile.component';
import { VendorSingupComponent } from './profile/vendor-singup/vendor-singup.component';
import { InvoiceHistoryComponent } from './reports/invoice-history/invoice-history.component';
import { authGuard } from './auth/auth.guard';
import { InformationChangeRequestComponent } from './forms/information-change-request/information-change-request.component';
import { PurchaseOrderHistoryComponent } from './reports/purchase-order-history/purchase-order-history.component';
import { VendorForgotPasswordComponent } from './profile/vendor-forgot-password/vendor-forgot-password.component';
import { NotFoundComponent } from './layout/util/not-found/not-found.component';
import { VendorResetPasswordComponent } from './profile/vendor-reset-password/vendor-reset-password.component';
import { InvoiceAccessGuard } from './auth/invoice-access.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: { title: 'login' },
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { title: 'home' },
      },
      {
        path: 'vendor-invoice',
        component: VendorInvoiceComponent,
        canActivate: [InvoiceAccessGuard],
        data: { title: 'vendor-invoice' },
      },
      {
        path: 'vendor-registration',
        component: VendorRegistrationComponent,
        data: { title: 'vendor-registration' },
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard],
        data: { title: 'profile' },
      },
      {
        path: 'vendor-sign-up',
        component: VendorSingupComponent,
        data: { title: 'profile' },
      },
      {
        path: 'vendor-forgot-password',
        component: VendorForgotPasswordComponent,
        data: { title: 'Forgot Password' },
      },
      {
        path: 'multiple-invoices',
        component: MultipleInvoicesComponent,
        canActivate: [InvoiceAccessGuard],
        data: { title: 'multiple-invoices' },
      },
      {
        path: 'invoice-history',
        component: InvoiceHistoryComponent,
        canActivate: [authGuard],
        data: { title: 'invoice-history' },
      },
      {
        path: 'information-change-request',
        component: InformationChangeRequestComponent,
        canActivate: [authGuard],
        data: { title: 'information-change-request' },
      },
      {
        path: 'purchase-order-history',
        component: PurchaseOrderHistoryComponent,
        canActivate: [authGuard],
        data: { title: 'purchase-order-history' },
      },
      {
        path: 'reset-password',
        component: VendorResetPasswordComponent,
        data: { title: 'Reset Password' },
      },
    ],
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: { title: '404 - Not Found' },
  },
  // Wildcard Route: Must be the last route
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: '404 - Not Found' },
  },
];
